import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HiDownload, HiEye, HiX } from 'react-icons/hi';
import './CV.css';

const CV_URL = '/sudip_majkoti_cv.pdf';

const CV = () => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <section id="cv" className="cv">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// Curriculum Vitae'}</span>
          <h2 className="section-title">My CV</h2>
          <p className="section-subtitle">
            Preview or download my CV to learn more about my qualifications and experience.
          </p>
        </div>

        <motion.div
          className="cv__content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="cv__preview-card">
            <div className="cv__embed-wrapper">
              <iframe
                src={`${CV_URL}#toolbar=0&navpanes=0`}
                title="CV Preview"
                className="cv__embed"
              />
              <div className="cv__embed-overlay" onClick={() => setPreviewOpen(true)}>
                <HiEye className="cv__overlay-icon" />
                <span>Click to expand</span>
              </div>
            </div>

            <div className="cv__actions">
              <button
                className="cv__btn cv__btn--preview"
                onClick={() => setPreviewOpen(true)}
              >
                <HiEye />
                <span>Preview CV</span>
              </button>
              <a
                href={CV_URL}
                download="Sudip_Majkoti_CV.pdf"
                className="cv__btn cv__btn--download"
              >
                <HiDownload />
                <span>Download CV</span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Fullscreen preview modal */}
      {previewOpen && (
        <motion.div
          className="cv__modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setPreviewOpen(false)}
        >
          <div className="cv__modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="cv__modal-header">
              <h3>CV Preview</h3>
              <div className="cv__modal-actions">
                <a
                  href={CV_URL}
                  download="Sudip_Majkoti_CV.pdf"
                  className="cv__btn cv__btn--download cv__btn--sm"
                >
                  <HiDownload />
                  <span>Download</span>
                </a>
                <button
                  className="cv__modal-close"
                  onClick={() => setPreviewOpen(false)}
                  aria-label="Close preview"
                >
                  <HiX />
                </button>
              </div>
            </div>
            <iframe
              src={CV_URL}
              title="CV Full Preview"
              className="cv__modal-iframe"
            />
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default CV;
